module.exports = __webpack_public_path__ + "static/media/inactive.02464f10.svg";